import { useState, useEffect, useMemo } from 'react';
import { subscribeTecnicos, tecnicosFallback } from '../services/tecnicosService';

// Color por técnico, en la misma forma que el viejo `tecnicoColors` de
// constants.js: { Benito: '#3B82F6', ..., Cliente: '#8B5CF6' }.
const COLOR_CLIENTE = '#8B5CF6';

// Roster de técnicos reactivo desde Firestore (colección `tecnicos`), con
// fallback automático a utils/constants mientras la colección esté vacía o no
// disponible. `soloActivos` filtra los dados de baja.
export function useTecnicos({ soloActivos = false } = {}) {
  const [tecnicos, setTecnicos]         = useState(() => tecnicosFallback());
  const [loading, setLoading]           = useState(true);
  const [fromFallback, setFromFallback] = useState(true);

  useEffect(() => {
    const unsub = subscribeTecnicos((list, meta = {}) => {
      setTecnicos(list);
      setFromFallback(!!meta.fromFallback);
      setLoading(false);
    });
    return unsub;
  }, []);

  return {
    tecnicos: soloActivos ? tecnicos.filter(t => t.activo) : tecnicos,
    loading,
    fromFallback,
  };
}

// Mapa { nombreTécnico: color, Cliente: '#8B5CF6' } derivado del roster.
export function useTecnicoColores() {
  const { tecnicos } = useTecnicos();
  return useMemo(() => ({
    ...Object.fromEntries(tecnicos.map(t => [t.nombre, t.color || '#6B7280'])),
    Cliente: COLOR_CLIENTE,
  }), [tecnicos]);
}
